import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { IntakeFormData } from "./IntakeFormSchema";

interface ConsentSectionProps {
  form: UseFormReturn<IntakeFormData>;
}

export function ConsentSection({ form }: ConsentSectionProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground border-b pb-2">Consent & Signature</h3>

      <div className="p-4 bg-muted/50 rounded-lg text-sm text-muted-foreground space-y-2">
        <p>
          By signing below, I certify that the information provided in this form is accurate and complete to the best of my knowledge.
        </p>
        <p>
          I authorize the release of medical information necessary to process claims. I also authorize payment of medical benefits to the provider of services.
        </p>
        <p>
          I understand that I am financially responsible for any charges not covered by my insurance plan.
        </p>
      </div>

      <FormField
        control={form.control}
        name="consent_given"
        render={({ field }) => (
          <FormItem className="flex items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                I agree to the terms and conditions stated above *
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="signature"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Electronic Signature *</FormLabel>
            <FormControl>
              <Input placeholder="Type your full legal name" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
